import { render, staticRenderFns } from "./SharingFee.vue?vue&type=template&id=53afe2f0&scoped=true&"
import script from "./SharingFee.vue?vue&type=script&lang=js&"
export * from "./SharingFee.vue?vue&type=script&lang=js&"
import style0 from "./SharingFee.vue?vue&type=style&index=0&id=53afe2f0&scoped=true&lang=css&"
import style1 from "./SharingFee.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53afe2f0",
  null
  
)

export default component.exports